
import {Badge, Skeleton } from '@mantine/core';
import intl from "react-intl-universal";


const IdentShowIDAustriaLoader = (props:any) => {  


  return (
    <>
    <Badge color="gray" variant="outline" fullWidth={true}>{intl.get('IDAUSTRIA_LOADER_WAITING')}</Badge>
    <Skeleton height={8} mt={6} radius="xl" />
    <Skeleton height={8} mt={6} radius="xl" width="80%"  />
    <Skeleton height={8} mt={6} radius="xl" />
    <Skeleton height={8} mt={6} width="70%" radius="xl" />
  </>
  );
}

export default IdentShowIDAustriaLoader;